<template>
  <div id="Solutions">
    <MyHeaderPage :title="$t('colocation.solutions.title')" />
    <br /><br />
    <div id="LinesList">
      <div class="listLines">
        <div class="mdl-grid" v-if="tab_index === 1">
          <div class="mdl-cell mdl-cell--4-col">
            <TextSearchInput
              @search="searchByString"
              @reset="resetSearchByString"
              :filterKey="'id'"
              :columns="['building', 'address', 'name']"
            />
          </div>
          <div class="mdl-cell mdl-cell--2-col"></div>
          <div
            class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone"
            v-show="tab_index !== 2"
          >
            <div class="helpText alignRight">
              <p class="textXL">{{ $t("help.generic.btnLabel") }}</p>
            </div>
          </div>
          <HelpRequestBtn
            v-if="tab_index !== 2"
            :component-name="'GenericIncidentFormColocation'"
            :asset-type="'colocation'"
            :icon="'warning'"
            :label="$t('help.incident.formTitle')"
            :element-class="'mdl-cell mdl-cell--1-col'"
          />
          <HelpRequestBtn
            v-if="tab_index !== 2"
            :component-name="'GenericChangeRequestFormColocation'"
            :asset-type="'colocation'"
            :icon="'person'"
            :label="$t('help.changeRequest.formTitle')"
            :element-class="'mdl-cell mdl-cell--1-col'"
          />
          <HelpRequestBtn
            v-if="tab_index !== 2 && false"
            :url="'/solutions/generic-help/colocation'"
            :icon="'settings'"
            :label="$t('help.techSupport.formTitle')"
            :element-class="'mdl-cell mdl-cell--1-col'"
          />
        </div>
        <div class="mdl-grid" v-else>
          <div class="mdl-cell mdl-cell--4-col">
            <TextSearchInput
              :disabled="!viewLoader"
              @search="searchByString"
              @reset="resetSearchByString"
              :filterKey="'ticketNumber'"
              :columns="['subject', 'cf_sold_solution']"
            />
          </div>
        </div>

        <TabContainer>
          <template #tabs>
            <Tab
              id="tabOne"
              :label="$t('tabs.listLabel')"
              @click="setTab(1)"
              :class="{ 'is-active': tab_index === 1 }"
            ></Tab>
            <Tab
              id="tabTwo"
              :label="$t('tabs.ticketListLabel')"
              @click="setTab(2)"
              :class="{ 'is-active': tab_index === 2 }"
            ></Tab>
          </template>
          <template #content>
            <div
              class="mdl-tabs__panel"
              :class="{ 'is-active': tab_index === 1 }"
              v-show="tab_index === 1"
            >
              <div class="mdl-grid">
                <div class="mdl-cell mdl-cell--4-col">
                  <span v-if="items" class="textInfo">{{
                    $t("colocation.itemCount", { total_count: totalItems })
                  }}</span>
                </div>
              </div>
              <List
                :list="filtered"
                :view-loader="viewLoader"
                :view-error="viewError"
                :total-page="total_page"
              />
            </div>
            <div
              class="mdl-tabs__panel"
              :class="{ 'is-active': tab_index === 2 }"
              v-show="tab_index === 2"
            >
              <ColocationTicketList
                :list="filtered"
                :view-loader="viewLoader"
                :view-error="viewError"
                :total-page="total_page"
                :total-count="total_count"
                :component-name-incident="'IncidentDetailColocation'"
                :component-name-change-request="'ChangeRequestDetailColocation'"
                @refresh="getTicketList"
                @change-page="onChangePage"
              />
            </div>
            <div class="mdl-grid" v-show="!viewLoader">
              <div class="mdl-cell mdl-cell--12-col" style="text-align: center">
                <MyLoading :viewLoader="viewLoader" type="" />
              </div>
            </div>
          </template>
        </TabContainer>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import MyLoading from "@/components/MyLoading.vue";
import List from "@/components/Colocation/List.vue";
import ColocationTicketList from "@/components/Colocation/TicketList.vue";
import TextSearchInput from "@/components/Search/TextSearch/TextSearchInput.vue";
import HelpRequestBtn from "@/components/Tables/HelpRequestBtn";
import TabContainer from "@/components/Utils/TabContainer.vue";
import Tab from "@/components/Utils/Tab.vue";
import "@/assets/scss/LinesList.scss";
import { filterDataByColumns } from "@/services/SearchService";

export default {
  name: "CoLocation",
  components: {
    MyHeaderPage,
    MyLoading,
    TextSearchInput,
    HelpRequestBtn,
    TabContainer,
    Tab,
    List,
    ColocationTicketList,
  },
  data() {
    return {
      items: [],
      filtered: [],
      search_columns: ["building", "address", "name"],
      tab_index: 1,
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
      viewLoader: true,
      viewError: false,
      totalItems: 0,
      page_size: 10,
      total_page: 1,
      total_count: 0,
      search_by_string_key: "",
    };
  },
  methods: {
    searchByString(keyword) {
      this.search_by_string_key = keyword;

      this.filtered = filterDataByColumns(
        this.items,
        this.search_columns,
        this.search_by_string_key
      );

      console.log(`${this.filtered.length} items found for ${keyword}`);

      // if no results are found in cache refresh data with search params
      if (!this.filtered.length) {
        this.filtered = [];
      }

      this.total_count = this.items.length;
    },
    resetSearchByString() {
      this.search_by_string_key = "";
      if (this.tab_index === 1) {
        this.getList();
      } else {
        this.getTicketList();
      }
    },
    setTab(index) {
      this.totalItems = 0;
      this.tab_index = index;
      this.search_by_string_key = "";
      if (index === 1) {
        this.search_columns = ["building", "address", "name"];
        this.getList();
      } else {
        this.search_columns = ["subject", "cf_sold_solution", "cf_short_title"];
        this.getTicketList();
      }
    },
    getList() {
      const URL = "assets/v1/colocation";
      this.viewLoader = false;
      this.updateView = 0;
      const self = this;

      this.axios
        .get(window.VUE_APP_MISTRA_URL + URL, {
          headers: this.he,
        })
        .then((response) => {
          self.filtered = response.data;
          self.items = response.data;
          self.viewLoader = true;
          this.totalItems = response.data.length;
        })
        .catch((err) => {
          const status = err?.response?.status ?? err?.request?.status;

          if (status === 404) {
            console.error("Url not found: ", URL);
            self.filtered = [];
            self.items = [];
            self.viewLoader = true;
            return;
          }

          self.viewLoader = true;

          if (status === 403) {
            self.filtered = [];
            self.items = [];
            return;
          }

          self.viewError = true;
          self.messageError = err.message;
          setTimeout(() => {
            self.viewError = false;
          }, 5000);
        });
    },
    getTicketList() {
      const URL = "tickets/v1/ticket-list";
      const TICKET_TYPE = "Incident,ChangeRequest,TechAssist";

      let params = {
        page_size: this.page_size,
        service: TICKET_TYPE,
        page: this.current_page,
        asset_type: "colocation",
      };

      this.viewLoader = false;
      this.total_count = 0;
      const self = this;

      if (this.search_by_string_key.length > 3) {
        params = {
          ...params,
          search_by: this.search_by_string_key,
          filter_by: this.sear,
        };
      }

      this.axios
        .post(window.VUE_APP_MISTRA_URL + URL, params, {
          headers: this.he,
        })
        .then((response) => {
          self.items = response.data.data;
          self.filtered = response.data.data;
          self.total_count = response.data.count;
          self.viewLoader = true;
        })
        .catch((err) => {
          const status = err?.response?.status ?? err?.request?.status;

          if (status === 404) {
            console.log("NOT FOUND");
            self.viewLoader = true;
            self.items = [];
            self.filtered = [];
            return;
          }

          self.viewLoader = true;

          if (status === 403) {
            self.items = [];
            self.filtered = [];
            return;
          }

          self.viewError = true;
          self.messageError = err.message;
          setTimeout(() => {
            self.viewError = false;
          }, 5000);
        });
    },
    // pagination method
    onChangePage(page) {
      this.current_page = page;
      if (this.tab_index === 2) {
        this.getTicketList();
      }
    },
    ctrlPerms(perms) {
      return this.$ctrlPermissions(perms);
    },
  },

  mounted() {
    window.scrollTo(0, 0);
    this.$IsLoggedIn();
    this.getList();
    // this.getTicketList();
  },
};
</script>
